import type { IUpdateLocationPrivacySettingsCmd } from "@/data/commands/location/UpdateLocationPrivacySettingsCmd";
import { Factory } from "@/data/dao/Factory";
import { LocationDao } from "@/data/dao/service/LocationDao";
import type { ILocationDetail } from "@/data/model/Location";

import { i18n } from "@/portal/Trans";
import { VisibleEndUserPropertiesSelect } from "@/portal/elements/VisibleEndUserPropertiesSelect";
import { Switch } from "@/portal/formControls/Switch";
import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class LocationPrivacySettingsForm extends BaseEntityForm<ILocationDetail, IUpdateLocationPrivacySettingsCmd> {
    private activeSwitch: Switch;
    private $retentionField: JQuery;
    private pushBernApiSwitch: Switch;
    private visibleEndUserPropertiesSelect: VisibleEndUserPropertiesSelect;

    constructor(element: JQuery) {
        super(element, {
            getSingle: undefined as any,
            create: undefined as any,
            getData: undefined as any,
            remove: undefined as any,
            update: (id, command) => Factory.getInstance<LocationDao>(LocationDao).setPrivacySettings(id, command),
        });

        this.activeSwitch = new Switch(this.$form.find('input[name="isactive"]'));
        this.activeSwitch.onChange = () => this.showHideActivatedFields();

        this.$retentionField = this.$form.find('input[name="retention"]');
        this.pushBernApiSwitch = new Switch(this.$form.find('input[name="pushbernapi"]'));

        this.visibleEndUserPropertiesSelect = new VisibleEndUserPropertiesSelect(
            this.$form.find('.form-control[name="visibleEndUserProperties"]')
        );
    }

    public setFormData(model?: ILocationDetail) {
        const privacySettings = model?.privacySettings;

        this.activeSwitch.setValue(privacySettings?.isActive ?? false);
        this.$retentionField.val(privacySettings?.retention as any);
        this.pushBernApiSwitch.setValue(privacySettings?.pushToBernApi ?? false);
        this.updateName(privacySettings === undefined ? "" : `${model!.name} ${i18n("location.covidContactTracing")}`);

        this.visibleEndUserPropertiesSelect.setValues(model?.privacySettings?.visibleEndUserProperties);

        this.showHideActivatedFields();
    }

    private showHideActivatedFields() {
        if (this.activeSwitch.getValue()) this.$form.find("#retentionrow, #pushbernapirow").show();
        else this.$form.find("#retentionrow, #pushbernapirow").hide();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getFormData($form: JQuery): IUpdateLocationPrivacySettingsCmd {
        const isActive = this.activeSwitch.getValue();

        const data = {
            isActive: isActive,
            retention: isActive
                ? this.$retentionField.val().length === 0
                    ? undefined
                    : parseInt(this.$retentionField.val())
                : undefined,
            pushToBernApi: isActive ? this.pushBernApiSwitch.getValue() : undefined,
            visibleEndUserProperties: this.visibleEndUserPropertiesSelect.getValue(),
        } as IUpdateLocationPrivacySettingsCmd;

        let hasError = false;
        this.$form.find(".is-invalid").removeClass("is-invalid");

        if (isActive) {
            if (data.retention !== undefined && (isNaN(data.retention) || data.retention <= 1)) {
                this.$retentionField.addClass("is-invalid");
                hasError = true;
            }
        }

        return (hasError ? undefined : data) as any;
    }
}
